module.exports = __webpack_public_path__ + "static/media/ruedasDigital_contacto.f55b4216.png";